module.exports = __webpack_public_path__ + "static/media/Sonic.e13912ae.TTF";